import StorageFolderList from './StorageFolderList/StorageFolderList';

export interface IAsset {
  id: number;
  name: string;
  folder_count: number
}

export interface IStorageProps {
  assets: IAsset[];
  refetchAssets: () => void;
  isLoading?: boolean;
}

const Storage = ({
  assets,
  refetchAssets,
  isLoading,
}: IStorageProps) => {
  return (
    <StorageFolderList
      assets={assets}
      refetchAssets={refetchAssets}
      isLoading={isLoading}
    />
  );
};

export default Storage;
